"use strict"
var logs = angular.module("logsModule", [
	'ui.router',
	'servicesModule',
	'ngResource',
	// 'angular-rickshaw',
	// "btford.socket-io"
]);
require('./js/directive/logsDirective.js')(logs);
require('./js/logsController.js')(logs);
require('./js/directive/singleLogDirective.js')(logs);


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/logsModule/logsModule.js
// module id = 509
// module chunks = 0